import { modals } from '@mantine/modals';
import { TFunction } from 'i18next';
import { TRANS_KEY_CONFIRM_MODAL } from '../../../../data';

export type OpenDeleteFavoriteConfirmModalParamsType = {
  onConfirm: () => void;
  t: TFunction;
};

export const openDeleteFavoriteConfirmModal = ({
  onConfirm,
  t,
}: OpenDeleteFavoriteConfirmModalParamsType): void => {
  modals.openConfirmModal({
    title: t(`${TRANS_KEY_CONFIRM_MODAL}.TITLE`),
    labels: {
      confirm: t(`${TRANS_KEY_CONFIRM_MODAL}.CONFIRM_BUTTON`),
      cancel: t('CANCEL_BUTTON'),
    },
    confirmProps: {
      color: 'red',
    },
    onConfirm,
  });
};
